exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ending-type .v-input--radio-group__input .v-radio .v-input--selection-controls__input{display:block!important}.custom-input .v-input__control .v-input__slot .v-select__slot input,.custom-input .v-input__control .v-input__slot .v-text-field__slot input{text-align:center!important}", ""]);

// exports
